export default "__VITE_ASSET__6cef4f5f__"